import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { drawResultSchema } from './drawResult.js';

export const drawResultResponseSchema = z
  .object({
    result: drawResultSchema,
  })
  .transform(({ result }) => ({ data: result }));

export const drawResultApiResponse = {
  parse: (data: unknown) => z.union([drawResultResponseSchema, apiErrorSchema]).parse(data),
} as const;
